import React, { Component } from 'react'
import { observer } from 'mobx-react'

import {
    Button,
    Col,
    Grid,
    Label,
    Row
} from 'react-bootstrap'

import InvoiceDetails from './invoicedetails'

@observer(['agreements', 'invoices', 'quickbooks', 'globals'])
export default class AccessoryView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            signature: '',
            loadableState: false
        }
    }

    //State Change Handlers
    signatureChanged(e) {
        this.setState({
            signature: e.target.value
        })
    }

    render() {
        let termsTable = ''
        if (this.props.invoices.invoiceViewDetails.agreementId > 0) {
            console.log('Agreement Id > 0')
            termsTable = 
                <div>
                    <div className="row hidden-print">
                        <div className="col-xs-12">
                            <p className="lead">Terms and Conditions</p>
                            <div className="agreement-container small-top-margin">
                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                            </div>
                        </div>
                    </div>
                    <div className="row visible-print">
                        <div className="col-xs-12">
                            <p className="lead">Terms and Conditions</p>
                            <div className="agreement-container-print small-top-margin">
                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                            </div>
                        </div>
                    </div>
                    <div className="row small-top-margin visible-print">
                        <div className="col-xs-12">
                            <div class="form-group">
                                <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                                    By signing your full name below, you agree to be bound by the terms and conditions detailed above.
                                </label>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Signature: </td>
                                            <td>________________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Name: </td>
                                            <td>________________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Date: </td>
                                            <td>________________________________</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        }

        var signaturePanel = (
            <div className="row small-top-margin hidden-print">
                <div className="col-xs-12">
                    <div class="form-group">
                        <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                            Electronic Signature: By typing your full name below, you agree to be bound by the details listed above.
                        </label><br />
                        <input type="text" className="form-control show-border" onChange={this.signatureChanged.bind(this)} placeholder="" />
                    </div>
                </div>
            </div>
        )

        let paymentNotification = ''
        let buttonDisplay = <Button className="btn btn-success pull-right fa fa-credit-card" onClick={() => { this.props.redirectProcessPaymentPage(this.props.invoices.invoiceViewDetails.invoiceId, this.state.signature) }}><i></i> Submit Payment</Button>

        if (this.props.invoices.invoiceViewDetails.paymentId !== null) {
            paymentNotification = <h2><strong>YOU HAVE ALREADY PROCESSED A PAYMENT FOR THIS INVOICE!</strong></h2>
            buttonDisplay = <Button disabled className="btn btn-success pull-right fa fa-credit-card" ><i></i> Payment Already Processed</Button>
            signaturePanel = ''
        }

        return (
            <div className="checkout-container">
                <Grid>
                    <Row>
                        <Col xs={0} md={2}></Col>
                        <Col xs={12} md={8}>
                            <Row>
                                <Col>
                                    <InvoiceDetails token={this.props.token} emailStatus={true} setLoadableState={ this.props.setLoadableState.bind(this) }/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {termsTable}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    { signaturePanel }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="row small-top-margin hidden-print">
                                        <div className="col-xs-12">
                                            {buttonDisplay}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={0} md={2} />
                    </Row>
                </Grid>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/invoices/accessoryview.js